<template>
  <v-container :class="{'px-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="my-4 mx-auto" style="max-width: 500px">

      <v-col cols="12">
        <h1 class="text-center accent--text mb-0">Восстановление пароля</h1>
      </v-col>

      <v-col cols="12">
        <v-card outlined class="base-card pa-8">
          <div v-if="confirmStep === 1">
            <v-row class="mx-0 mt-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-text-field
                  class="pa-0 pt-2 ma-0"
                  v-model="form.email"
                  label="Электронная почта"
                  :error-messages="emailErrors"
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"
                />
              </v-col>
            </v-row>

            <v-row class="mx-0 mb-0">
              <v-col cols="4" class="pa-0 mt-4">
                <v-btn
                  depressed
                  color="primary"
                  class="mr-2"
                  :loading="loading"
                  :disabled="$v.form.$invalid"
                  @click="startReset"
                >
                  Отправить
                </v-btn>
              </v-col>

              <v-col cols="8" class="pa-0 mt-5 d-flex justify-end">
                <v-btn text small color="primary" class="pr-2" to="/login">
                  Страница входа
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div v-if="confirmStep === 2">
            <v-row class="mx-0 my-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-alert type="info" outlined class="body-2 mb-0">
                  На Ваш почтовый ящик отправлено письмо, содержащее ссылку для подтверждения нового пароля
                </v-alert>
              </v-col>
            </v-row>
          </div>

          <div v-if="confirmStep === 3">
            <PasswordCreate
              :confirmParams="confirmParams"
              type="forget"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authApi } from '@/api'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import PasswordCreate from '@/components/auth/PasswordCreate'

export default {
  name: "ForgetPassword",

  components: {
    PasswordCreate
  },

  metaInfo: {
    title: 'Восстановление пароля'
  },

  created() {
    this.setBaseConfirmStep()
  },

  data: () => ({
    confirmStep: null, // 1, 2, 3
    loading: false,
    form: {
      email: null
    },
    confirmParams: {
      login: null,
      code: null
    }
  }),

  validations() {
    return {
      form: {
        email: {
          required,
          email,
          maxLength: maxLength(50)
        }
      }
    }
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.email && errors.push('E-mail невалидный')
      return errors
    }
  },

  methods: {
    setBaseConfirmStep() {
      if (this.$route.name === 'forget') {
        this.confirmStep = 1
      } else if (this.$route.name === 'forgetConfirm') {
        this.confirmStep = 3
        this.confirmParams.login = this.$route.params.login
        this.confirmParams.code = this.$route.params.code
      }
    },

    async startReset() {
      try {
        this.loading = true

        await authApi.startReset(this.form.email)
        this.confirmStep = 2
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сброса пароля')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>